// Grid constants
const COLUMNS = 4;
const ROWS = 3;

export const BARON_WUFFETT_SPRITE_SHEET =
  '/assets/baron-wuffett/baron-wuffett-gestures.png';

type GesturePosition = { row: number; col: number };

const baronWuffettLabels = {
  'baron-wuffett-point-up': { row: 1, col: 1 },
  'baron-wuffett-ponder': { row: 1, col: 2 },
  'baron-wuffett-point-right-coin': { row: 1, col: 3 },
  // (1,4) is intentionally empty — omitted from the map
  'baron-wuffett-money-bag': { row: 2, col: 1 },
  'baron-wuffett-reading': { row: 2, col: 2 },
  'baron-wuffett-thumbs-up': { row: 2, col: 3 },
  'baron-wuffett-arms-crossed': { row: 2, col: 4 },
  'baron-wuffett-neutral': { row: 3, col: 1 },
  // (3,2) baron-wuffett-confident removed — drawn incorrectly
  'baron-wuffett-writing': { row: 3, col: 3 },
  'baron-wuffett-smile': { row: 3, col: 4 },
} as const satisfies Record<string, GesturePosition>;

export type BaronWuffettGesture = keyof typeof baronWuffettLabels;

export const DEFAULT_GESTURE: BaronWuffettGesture = 'baron-wuffett-neutral';

export function getGesturePosition(
  key: BaronWuffettGesture,
): GesturePosition {
  const position = baronWuffettLabels[key];
  if (!position) {
    const available = Object.keys(baronWuffettLabels).join(', ');
    throw new Error(
      `Invalid gesture key "${key}". Available keys: ${available}`,
    );
  }
  return position;
}

export function getSpriteStyles(key: BaronWuffettGesture): {
  backgroundImage: string;
  backgroundSize: string;
  backgroundPosition: string;
} {
  const { row, col } = getGesturePosition(key);

  const xPercent = ((col - 1) / (COLUMNS - 1)) * 100;
  const yPercent = ((row - 1) / (ROWS - 1)) * 100;

  return {
    backgroundImage: `url(${BARON_WUFFETT_SPRITE_SHEET})`,
    backgroundSize: `${COLUMNS * 100}% ${ROWS * 100}%`,
    backgroundPosition: `${xPercent}% ${yPercent}%`,
  };
}

export { baronWuffettLabels };
